import ReportPage from './ReportPage'

export default function PedidosReport({className = ''}: {className?: string}) {
  return <ReportPage type='pedidos' className={className} />
}
